import { APIInstance } from 'config';
import { API } from 'constants/apiEndpoints';
import { PAGINATION2_TYPE, RESPONSE_TYPE } from 'models';
import {
  AVAILABLE_PACKAGE_RESPONSE,
  GET_PACKAGE_PARAMS,
  GET_SUBSCRIPTION_PURCHASED_PARAMS,
  GET_TRANSACTION_HISTORY_BY_CASH_PARAMS,
  GET_TRANSACTION_HISTORY_PARAMS,
  SUBSCRIPTION_PURCHASED_RESPONSE,
  TRANSACTION_HISTORY_BY_CASH_RESPONSE,
  TRANSACTION_HISTORY_BY_CREDIT_RESPONSE,
} from 'models/credits';

export const creditsApi = {
  getCurrentBalanceCredit: async (id: string) => {
    return APIInstance.get<RESPONSE_TYPE<number>>(
      `${API.CREDITS.GET_BALANCE(id)}`,
    );
  },
  getPackagesList: async (
    params?: GET_PACKAGE_PARAMS,
  ): Promise<AVAILABLE_PACKAGE_RESPONSE> => {
    return APIInstance.get(API.CREDITS.GET_PACKAGES, {
      params,
    });
  },
  getSubscriptionPurchased: async (
    params: GET_SUBSCRIPTION_PURCHASED_PARAMS,
  ): Promise<
    RESPONSE_TYPE<PAGINATION2_TYPE<SUBSCRIPTION_PURCHASED_RESPONSE[]>>
  > => {
    return APIInstance.get(API.CREDITS.SUBSCRIPTION_PURCHASE, {
      params,
    });
  },
  getTransactionHistoryByCredit: async (
    params: GET_TRANSACTION_HISTORY_PARAMS,
  ): Promise<RESPONSE_TYPE<TRANSACTION_HISTORY_BY_CREDIT_RESPONSE>> => {
    return APIInstance.get(API.CREDITS.TRANSACTION_HISTORY_BY_CREDIT, {
      params,
    });
  },
  getTransactionHistoryByCash: async (
    params: GET_TRANSACTION_HISTORY_BY_CASH_PARAMS,
  ): Promise<RESPONSE_TYPE<TRANSACTION_HISTORY_BY_CASH_RESPONSE>> => {
    return APIInstance.get(API.CREDITS.TRANSACTION_HISTORY_BY_CASH, {
      params,
    });
  },
};
